import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import ApiHome from "../../core/api/api.home";
import "./dashboard-redesign.css";

const fa = (name, tone) => `fas${!!tone ? ` dr-${tone}` : ""} ${name}`;

const formatCount = (value) =>
  Number(value ?? 0).toLocaleString("fa-IR");

function MetricCard({ icon, label, value, tone, hint, onClick }) {
  return (
    <button type="button" className="dr-metric" onClick={onClick}>
      <span className={`dr-metric__icon dr-${tone}`}><i className={fa(icon, tone)} /></span>
      <span className="dr-metric__content">
        <span className="dr-metric__label">{label}</span>
        <strong className="dr-metric__value">{formatCount(value)}</strong>
        <small>{hint}</small>
      </span>
      <span className="dr-metric__arrow"><i className="fas fa-arrow-left" /></span>
    </button>
  );
}

function Heading({ icon, title, subtitle }) {
  return (
    <div className="dr-heading">
      <span className="dr-heading__icon"><i className={fa(icon)} /></span>
      <div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
    </div>
  );
}

export default function DashboardPage() {
  const navigate = useNavigate()
  const [dashboardInfo, setDashboardInfo] = useState({});
  const cooperationCount = useMemo(() => dashboardInfo?.pendingCooperationRequestCount ?? 0, [dashboardInfo]);

  const metrics = useMemo(() => [
    {
      key: "pendingPaymentToSupplierCount",
      label: "پرداخت به تأمین‌کنندگان",
      icon: "fa-wallet",
      tone: "orange",
      hint: "مورد در انتظار اقدام",
      route: "/basketItemPerson",
    },
    {
      key: "pendingSupplierAutoSettlementCount",
      label: "تسویه تأمین‌کنندگان",
      icon: "fa-file-invoice-dollar",
      tone: "purple",
      hint: "مورد نیازمند پیگیری",
      route: "/amusementServiceReserveItem",
    },
    // {
    //   key: "pendingCooperationRequestCount",
    //   label: "درخواست همکاری",
    //   icon: "fa-handshake",
    //   tone: "teal",
    //   hint: "پیش‌ثبت‌نام جدید",
    //   route: "/cooperationRequest",
    // },
  ], []);

  useEffect(() => {
    const fetchData = async () => {
      const panelInfo = await ApiHome.getPanelDashboard();
      setDashboardInfo(panelInfo);
    };

    fetchData();
  }, []);

  return (
    <main className="dashboard-redesign container-fluid" dir="rtl">
      <header className="dr-welcome">
        <div>
          {/* <span className="dr-eyebrow"><span className="dr-live-dot" /> نمای کلی پنل مدیریت</span> */}
          <h1>داشبورد مدیریت</h1>
          <p>مهم‌ترین موارد و کارهای نیازمند پیگیری، یک‌جا و در یک نگاه.</p>
        </div>
        <div className="dr-welcome__art" aria-hidden="true">
          <span className="dr-orbit dr-orbit--one" />
          <span className="dr-orbit dr-orbit--two" />
          <i className="fas fa-chart-line text-white" />
        </div>
      </header>

      <section className={`dr-priority ${Number(cooperationCount) > 0 ? "dr-priority--active" : "dr-priority--empty"}`}>
        <div className="dr-priority__icon">
          <i className={`fas ${Number(cooperationCount) <= 0 ? "text-success" : "text-warning"} ${Number(cooperationCount) > 0 ? "fa-bell" : "fa-check-circle"}`} />
          {Number(cooperationCount) > 0 && <span />}
        </div>
        <div className="dr-priority__copy">
          <small>{Number(cooperationCount) > 0 ? "نیازمند بررسی شما" : "همه درخواست‌ها بررسی شده‌اند"}</small>
          <h2>
            {Number(cooperationCount) > 0
              ? `${formatCount(cooperationCount)} درخواست همکاری در انتظار بررسی است`
              : "درخواست همکاریِ بررسی‌نشده‌ای ندارید"}
          </h2>
          <p>
            {Number(cooperationCount) > 0
              ? "پس از تماس با متقاضی، نتیجه همکاری را ثبت کنید."
              : "در صورت ثبت درخواست جدید، وضعیت آن در همین بخش نمایش داده می‌شود."}
          </p>
        </div>
        {Number(cooperationCount) > 0 && (
          <button type="button" className="dr-priority__button text-white" onClick={() => navigate("/cooperationRequest")}>
            بررسی درخواست‌ها <i className="fas fa-arrow-left me-2 p-0 text-white position-relative" style={{ top: 2 }} />
          </button>
        )}
      </section>

      <div className="dr-section-top">
        <Heading icon="fa-layer-group" title="موارد نیازمند پیگیری" subtitle="برای مشاهده جزئیات هر بخش، روی کارت آن کلیک کنید." />
        {/* <span className="dr-data-label"><span /> اطلاعات دریافتی از پنل</span> */}
      </div>

      <section className="dr-metrics">
        {metrics.map((metric) => (
          <MetricCard
            key={metric.key}
            {...metric}
            value={dashboardInfo[metric.key]}
            onClick={() => navigate(metric.route)}
          />
        ))}
      </section>

      {/* <section className="dr-shortcuts-panel">
        <Heading icon="fa-bolt" title="دسترسی سریع" subtitle="مسیرهای پرکاربرد مدیریت" />
        <div className="dr-shortcuts">
          <button type="button" className="dr-shortcut" onClick={() => onNavigate("cooperationRequests")}>
            <span className="dr-shortcut__icon dr-teal"><i className="fas fa-handshake" /></span>
            <span className="dr-shortcut__copy"><strong>درخواست‌های همکاری</strong><small>بررسی و تعیین نتیجه درخواست‌ها</small></span>
            {Number(cooperationCount) > 0 && <b className="dr-shortcut__count">{formatCount(cooperationCount)}</b>}
            <i className="fas fa-chevron-left dr-chevron" />
          </button>
          <button type="button" className="dr-shortcut" onClick={() => onNavigate("suppliers")}>
            <span className="dr-shortcut__icon dr-blue"><i className="fas fa-store" /></span>
            <span className="dr-shortcut__copy"><strong>تأمین‌کنندگان</strong><small>مشاهده فهرست تأمین‌کنندگان</small></span>
            <i className="fas fa-chevron-left dr-chevron" />
          </button>
          <button type="button" className="dr-shortcut" onClick={() => onNavigate("reports")}>
            <span className="dr-shortcut__icon dr-purple"><i className="fas fa-chart-pie" /></span>
            <span className="dr-shortcut__copy"><strong>گزارش‌ها</strong><small>مرور گزارش‌های مدیریتی</small></span>
            <i className="fas fa-chevron-left dr-chevron" />
          </button>
        </div>
      </section> */}
    </main>
  );
}
